import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-back-button-quality',
  templateUrl: './back-button-quality.component.html',
  styleUrls: ['./back-button-quality.component.css'],
})
export class BackButtonQualityComponent {
  @Input() backButton = true
  @Input() isCollapsed: boolean = false; // 👉 recibe el estado
  @Input() volver: boolean = true; // 👉 recibe el estado
}
